<template>
  <nuxt-link to="/nomad">
    <icon class="icon" name="nomad:diamond" size="2rem" />
    <span class="label">Bibliothèque N+</span>
    <div class="arrow">
      <Icon class="graphic arrow-off" name="nextSmall" size="1.8rem" />
      <Icon class="graphic arrow-on" name="nextSmall" size="1.8rem" />
    </div>
  </nuxt-link>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
a {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  width: 100%;
  padding: var(--gap_s);
  transition: border-color 300ms $ease-out-quad, color 300ms $ease-in-quad,
    background-color 200ms $ease-out-quad;
  border-width: var(--stroke_thickness_s);
  border-style: solid;
  border-radius: 2rem;
  border-color: var(--color_secondary_light);
  background-color: var(--color_neutral_25);
  color: var(--color_secondary_darker);
  gap: var(--gap_s);
  @include font('s', 700, 'secondary');
  .label {
    width: fit-content;
  }
  .arrow {
    position: relative;
    align-self: center;
    width: 1.8rem;
    height: 1.8rem;
    color: var(--color_secondary);
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 0.6rem;
      opacity: 0.15;
      background-color: var(--color_primary_light);
    }
    .graphic {
      position: absolute;
      top: 0;
      left: 0;
      transform: translateX(0) scale(1);
      transition: transform 400ms $ease-out-back 200ms,
        opacity 50ms $ease-in-quad 200ms;
      opacity: 1;
      color: var(--color_primary);
    }
    .arrow-on {
      transform: translateX(-1.4rem) scale(0.8);
      transition: transform 400ms $ease-in-quad,
        opacity 50ms $ease-in-quad 100ms;
      opacity: 0;
      color: var(--color_primary);
    }
  }

  &:hover,
  &:focus,
  &.active,
  &.router-link-active,
  &.router-link-exact-active-with-hash {
    @include pointer-desktop {
      color: var(--color_primary);
      .icon {
        transform: scale(1.3);
        transition: transform 500ms $ease-out-back;
      }
      .arrow-on {
        transform: translateX(0) scale(1);
        transition: transform 350ms $ease-out-back 200ms,
          opacity 80ms $ease-in-circ 200ms;
        opacity: 1;
      }
      .arrow-off {
        transform: translateX(1.8rem) scale(0.6);
        transition: transform 250ms $ease-in-back,
          opacity 100ms $ease-out-quad 160ms;
        opacity: 0;
      }
    }
  }
  &.router-link-active,
  &.router-link-exact-active-with-hash {
    &.main {
      background-color: var(--color_secondary_light);
    }
  }
}
</style>
